document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("newDropsModal");
  const trigger = document.querySelector(".new-drops-trigger");

  if (!modal || !trigger) return;

  const closeBtn = modal.querySelector(".new-drops-modal__close");
  const overlay = modal.querySelector(".new-drops-modal__overlay");
  const firstFocusable = modal.querySelector("button, input, a, textarea");

  const openModal = () => {
    modal.classList.add("is-active");
    document.body.style.overflow = "hidden";
    firstFocusable?.focus();
  };

  const closeModal = () => {
    modal.classList.remove("is-active");
    document.body.style.overflow = "";
  };

  trigger.addEventListener("click", openModal);

  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  if (overlay) {
    overlay.addEventListener("click", closeModal);
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-active")) {
      closeModal();
    }
  });
});
